import PartyEdit from '@/views/PartyEdit.vue'

export const PARTY_EDIT_SECTIONS = [
  { icon: 'person', route: 'personal-details', title: 'Personal Details' },
  { icon: 'groups', route: 'family', title: 'Family' },
  { icon: 'explore', route: 'background', title: 'Background' },
  { icon: 'alt_route', route: 'history', title: 'History' },
  { icon: 'mdi-account-check', route: 'eligibility-assistant', title: 'Eligibility Assistant' },
  { icon: 'assistant', route: 'asylum-assistant', title: 'Asylum Assistant' },
  { icon: 'list', route: 'long-term-options', title: 'Long Term Options' },
  { icon: 'quiz', route: 'party-surveys', title: 'Party Surveys' },
]

const defaultMeta = {
  requiresAuth: true,
  tmetric: {
    enabled: true,
    resource: 'party',
  },
}

export default {
  path: '/party/:id/edit',
  name: 'partyEdit',
  meta: defaultMeta,
  component: PartyEdit,
  props: true,
  redirect: { name: 'pe-personal-details' },
  children: [
    {
      path: 'personal-details',
      name: 'pe-personal-details',
      meta: { ...defaultMeta, sectionName: 'Personal Details' },
      props: true,
      component: _ => import('@/components/Party/PartyEdit/PEPersonalDetails.vue'),
    },
    {
      path: 'overview',
      name: 'pe-overview',
      meta: { ...defaultMeta, sectionName: 'Overview' },
      props: true,
      component: _ => import('@/components/Party/PartyEdit/PEOverview.vue'),
    },
    {
      path: 'family',
      name: 'pe-family',
      meta: { ...defaultMeta, sectionName: 'Family' },
      props: true,
      component: _ => import('@/components/Party/PartyEdit/PEFamilies.vue'),
    },
    {
      path: 'background',
      name: 'pe-background',
      meta: { ...defaultMeta, sectionName: 'Background' },
      props: true,
      component: _ => import('@/components/Party/PartyEdit/PEBackground.vue'),
    },
    {
      path: 'history',
      name: 'pe-history',
      meta: { ...defaultMeta, sectionName: 'History' },
      props: true,
      component: _ => import('@/components/Party/PartyEdit/PEHistory.vue'),
    },
    {
      path: 'eligibility-assistant',
      name: 'pe-eligibility-assistant',
      meta: { ...defaultMeta, sectionName: 'Eligibility Assistant' },
      props: true,
      component: _ => import('@/components/Party/PartyEdit/PEElligibilityAssistant.vue'),
    },
    {
      path: 'asylum-assistant',
      name: 'pe-asylum-assistant',
      meta: { ...defaultMeta, sectionName: 'Asylum Assistant' },
      props: true,
      component: _ => import('@/components/Party/PartyEdit/PEAsylumAssistant.vue'),
    },
    {
      path: 'long-term-options',
      name: 'pe-long-term-options',
      meta: { ...defaultMeta, sectionName: 'Long Term Options' },
      props: true,
      component: _ => import('@/components/Party/PartyEdit/PELongTermOptions.vue'),
    },
    {
      path: 'party-surveys',
      name: 'pe-party-surveys',
      meta: { ...defaultMeta, sectionName: 'Party Surveys' },
      props: true,
      component: _ => import('@/components/Party/PartyEdit/PESurveys.vue'),
    },
  ],
}
